import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Table from './Table';
import { personService } from '@shared/services/personService';

export default function PersonPicker({
    title = 'Избор на лице',
    onSelectPerson,
    onCancel,
}) {
    const { t } = useTranslation();

    const [persons, setPersons] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);
    const [searchQuery, setSearchQuery] = useState({});
    const [searchType, setSearchType] = useState('name');

    const getPersons = async ({
        nextSearchQuery = searchQuery,
        nextSearchType = searchType,
        nextPageNumber = pageNumber,
        nextPageSize = pageSize,
    } = {}) => {
        try {
            setLoading(true);
            const res = await personService.getPersons({
                searchQuery: nextSearchQuery,
                searchType: nextSearchType,
                pageNumber: nextPageNumber,
                pageSize: nextPageSize,
            });
            const rawContent = res.content || [];

            const mapped = rawContent.map((p) => {
                const rawIdn = p.idn;
                let flatIdn = '';
                if (typeof rawIdn === 'string') {
                    flatIdn = rawIdn;
                } else if (rawIdn && typeof rawIdn === 'object') {
                    flatIdn = rawIdn.idn || '';
                }
                return { ...p, idn: flatIdn };
            });

            setPersons(mapped);
            setTotalPages(res.totalPages || 0);
            setTotalElements(res.totalElements || 0);
            setPageNumber(res.pageNumber ?? nextPageNumber ?? 0);
        } catch (error) {
            console.error('Error fetching persons:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSearchClick = () => {
        getPersons({
            nextSearchQuery: searchQuery,
            nextSearchType: searchType,
            nextPageNumber: 0,
            nextPageSize: pageSize,
        });
    };

    useEffect(() => {
        getPersons({
            nextSearchQuery: searchQuery,
            nextSearchType: searchType,
            nextPageNumber: 0,
            nextPageSize: pageSize,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="main-person-form-container">
            <Table
                title={title}
                columns={[
                    { key: 'name', label: t('users.table.headers.firstName') || 'Name' },
                    { key: 'idn', label: t('users.table.headers.idn') || 'IDN' },
                ]}
                data={persons}
                loading={loading}
                showPageSizeSelector={true}
                showPagination={true}
                showCustomSearch={false}
                searchOptions={[
                    { key: 'name', label: 'name' },
                    { key: 'idn', label: 'idn' },
                ]}
                pageNumber={pageNumber}
                totalPages={totalPages}
                totalElements={totalElements}
                pageSize={pageSize}
                setpageNumber={setPageNumber}
                setPageSize={setPageSize}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                searchType={searchType}
                setSearchType={setSearchType}
                handleSearchClick={handleSearchClick}
                getData={() => getPersons()}
                handleRowClick={(rowIndex) => {
                    const source = Array.isArray(persons?.content) ? persons.content : persons;
                    const selected = Array.isArray(source) ? source[rowIndex] : null;
                    if (selected && onSelectPerson) {
                        onSelectPerson(selected);
                    }
                }}
            />
            <div className="flex-row justify-center" style={{ marginTop: '10px' }}>
                <button type="button" className="form-btn btn-red" onClick={onCancel}>
                    {t('common.goBack') || 'Back'}
                </button>
            </div>
        </div>
    );
}
